import { render, staticRenderFns } from "./SectionMarie.vue?vue&type=template&id=54bcec2d&scoped=true&"
import script from "./SectionMarie.vue?vue&type=script&lang=js&"
export * from "./SectionMarie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bcec2d",
  null
  
)

export default component.exports